import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export const Blank = () => {
  return (
    <Box
      border={{
        bottom: {
          width: 's1',
          style: 'hidden',
          color: 'grey400',
        },
      }}
    >
      <Box padding="s24" alignItems="center">
        <Text.Normal weight="medium">
          {i18n.t('surveys.review.reviews.split_view.blank_slate')}
        </Text.Normal>
      </Box>
    </Box>
  )
}
